/**
 * <flex-price-slider> — Von-bis-Doppelslider im Preis-Filter.
 * Synchronisiert sich mit Dawns Von/Bis-Zahlenfeldern im selben
 * <price-range>: Slider bewegen aktualisiert die Felder (das bubbelnde
 * input-Event stößt Dawns debouncierten Filter-Submit an), Tippen in die
 * Felder zieht die Slider nach. Custom Element, damit es Dawns
 * AJAX-Neu-Rendering der Facetten (innerHTML-Replace) überlebt.
 */
class FlexPriceSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.init) return;
    this.dataset.init = "1";
    const priceRange = this.closest("price-range");
    if (!priceRange) return;
    const nums = priceRange.querySelectorAll('input[type="number"]');
    if (nums.length < 2) return;
    this.numMin = nums[0];
    this.numMax = nums[1];
    const thumbs = this.querySelectorAll('input[type="range"]');
    this.lo = thumbs[0];
    this.hi = thumbs[1];
    this.fill = this.querySelector(".flex-pricerange__fill");
    this.cap = Number(this.dataset.max) || Number(this.hi.max) || 100;

    const syncFromNumbers = () => {
      this.lo.value = String(Math.min(this.cap, Number(this.numMin.value || 0)));
      this.hi.value = String(
        this.numMax.value === "" ? this.cap : Math.min(this.cap, Number(this.numMax.value)),
      );
      this.paint();
    };
    syncFromNumbers();

    const onSlide = (e) => {
      let lo = Number(this.lo.value);
      let hi = Number(this.hi.value);
      if (lo > hi) {
        if (e.target === this.lo) {
          lo = hi;
          this.lo.value = String(lo);
        } else {
          hi = lo;
          this.hi.value = String(hi);
        }
      }
      // Leere Felder = Grenze nicht gesetzt (wie Dawn-Placeholder)
      this.numMin.value = lo > 0 ? String(lo) : "";
      this.numMax.value = hi < this.cap ? String(hi) : "";
      this.paint();
    };
    thumbs.forEach((t) => t.addEventListener("input", onSlide));
    priceRange.addEventListener("input", (e) => {
      if (e.target === this.numMin || e.target === this.numMax) syncFromNumbers();
    });
  }

  paint() {
    if (!this.fill) return;
    const lo = (Number(this.lo.value) / this.cap) * 100;
    const hi = (Number(this.hi.value) / this.cap) * 100;
    this.fill.style.left = Math.max(0, lo) + "%";
    this.fill.style.right = Math.max(0, 100 - hi) + "%";
  }
}
if (!customElements.get("flex-price-slider")) {
  customElements.define("flex-price-slider", FlexPriceSlider);
}

/**
 * Filter-Drawer unterhalb der Header-Bar öffnen (wie der Menü-Drawer).
 * Dawn pflegt --header-bottom-position nur beim Menü-Drawer (HeaderDrawer);
 * hier wird sie auch beim Öffnen des Filter-Drawers frisch gesetzt —
 * das CSS hängt das Overlay an diese Kante.
 */
(function () {
  const setHeaderBottom = () => {
    const header = document.querySelector(".section-header");
    if (!header) return;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + "px",
    );
  };
  document.addEventListener("click", (e) => {
    if (e.target.closest(".mobile-facets__wrapper summary")) setHeaderBottom();
  });
  window.addEventListener("resize", () => {
    const open = document.querySelector(".mobile-facets__wrapper details[open]");
    if (open) setHeaderBottom();
  });
})();

/**
 * Eigenes Sortier-Dropdown im Popover-Design — das native <select> bleibt
 * unsichtbar im DOM und wird weiterbedient (value + bubbelndes input-Event
 * stößt Dawns Filter-Submit an). Re-Enhancement nach Dawns AJAX-Rerender
 * über MutationObserver.
 */
(function () {
  var CARET =
    '<svg class="flex-sortmenu__caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function closeAll() {
    document.querySelectorAll(".flex-sortmenu__list:not([hidden])").forEach(function (l) {
      l.hidden = true;
      var btn = l.parentElement.querySelector(".flex-sortmenu__btn");
      if (btn) {
        btn.classList.remove("open");
        btn.setAttribute("aria-expanded", "false");
      }
    });
  }

  function enhance(select) {
    if (select.dataset.flexEnhanced) return;
    select.dataset.flexEnhanced = "1";
    var wrap = select.closest(".select") || select.parentElement;
    var menu = document.createElement("div");
    menu.className = "flex-sortmenu";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "flex-sortmenu__btn";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    var list = document.createElement("ul");
    list.className = "flex-sortmenu__list";
    list.setAttribute("role", "listbox");
    list.hidden = true;

    function rebuild() {
      var current = select.options[select.selectedIndex];
      btn.innerHTML = "<span>" + (current ? current.text : "") + "</span>" + CARET;
      list.innerHTML = "";
      Array.prototype.forEach.call(select.options, function (o) {
        var li = document.createElement("li");
        li.setAttribute("role", "option");
        li.setAttribute("tabindex", "0");
        li.setAttribute("aria-selected", o.selected ? "true" : "false");
        li.className = "flex-sortmenu__opt" + (o.selected ? " is-active" : "");
        li.dataset.value = o.value;
        li.textContent = o.text;
        list.appendChild(li);
      });
    }
    rebuild();

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var wasOpen = !list.hidden;
      closeAll();
      if (wasOpen) return;
      list.hidden = false;
      btn.classList.add("open");
      btn.setAttribute("aria-expanded", "true");
    });
    function choose(li) {
      select.value = li.dataset.value;
      rebuild();
      closeAll();
      select.dispatchEvent(new Event("input", { bubbles: true }));
    }
    list.addEventListener("click", function (e) {
      var li = e.target.closest("li");
      if (li) choose(li);
    });
    list.addEventListener("keydown", function (e) {
      var li = e.target.closest("li");
      if (li && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        choose(li);
      }
    });

    menu.appendChild(btn);
    menu.appendChild(list);
    wrap.after(menu);
    wrap.classList.add("flex-sortmenu-native");
  }

  function enhanceAll() {
    document
      .querySelectorAll("select.facet-filters__sort, .mobile-facets__sort select")
      .forEach(enhance);
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".flex-sortmenu")) closeAll();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll();
  });
  enhanceAll();
  new MutationObserver(function () {
    enhanceAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
